<template>
  <section class="step-btm-container">
    <div v-if="veriff" :id="veriffId"></div>

    <a-row type="flex" justify="start" align="middle" :gutter="16">
      <a-col :span="6" flex="100px">
        <a-button
          type="link"
          :size="uiSize"
          block
          @click="prevStep"
          class="step-btm-back-btn"
        >
          <IconBack />
          {{ $t("Back") }}
        </a-button>
      </a-col>
      <a-col :span="6" flex="auto" :offset="6">
        <a-button
          v-if="showVerifyButton"
          class="step-btm-verify-btn"
          type="primary"
          block
          :size="uiSize"
          :disabled="!passed"
          :loading="loading"
          @click="verifyIdentity"
        >
          {{ veriff.text }}
        </a-button>
        <a-button
          v-else
          class="step-btm-next-btn"
          type="primary"
          block
          :size="uiSize"
          :disabled="!passed"
          :loading="loading"
          @click="submitForm"
        >
          {{ $t("Save and continue") }}
        </a-button>
      </a-col>
    </a-row>

    <a-modal
      title=""
      :visible="modal2Visible"
      centered
      :okText="$t('Yes,submit')"
      :cancelText="$t('Cancel')"
      :getContainer="() => $root.$el"
      @ok="confirm"
      @cancel="modal2Visible = false"
    >
      <h5>{{ $t("dialog_context") }}</h5>
    </a-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Divider, Checkbox, Button, Row, Col, Modal } from "ant-design-vue";
import { MESSAGES } from "@veriff/incontext-sdk";
import IconBack from "@/components/icon-back.svg";
import { getVeriffStatus, doSubmit } from "@/api/kyc";
import { displayErrors } from "@/utils";
import { initVeriff, createVeriffFrame } from "./kyc/utils";

export default {
  name: "BtmStepNavInstitution",
  data() {
    return {
      veriffStatus: "",
      veriffId: "veriff-root",
      veriffFrame: null,
      modal2Visible: false
    };
  },
  props: {
    passed: [String, Boolean],
    loading: [Boolean],
    veriff: {
      type: [Boolean, Object],
      defalt: false
    }
  },
  components: {
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Modal.name]: Modal,
    IconBack
  },
  computed: {
    ...mapState("KYC", ["currentStep4Institution", "kycStepLists4Institution"]),
    ...mapState({
      uiSize: state => state.clientInfo.uiSize
    }),
    showVerifyButton() {
      return this.veriff && this.veriffStatus !== MESSAGES.FINISHED;
    }
  },
  methods: {
    ...mapActions("KYC", ["changeCurrentStep4Institution"]),
    prevStep() {
      if (this.currentStep4Institution == 0) {
        this.$router.back();
        return;
      } else {
        this.changeCurrentStep4Institution(this.currentStep4Institution - 1);
      }
    },
    nextStep(res) {
      if (!res) {
        return;
      } else if (
        this.currentStep4Institution ==
        Object.keys(this.kycStepLists4Institution).length - 1
      ) {
        this.modal2Visible = true;
        return;
      } else {
        this.changeCurrentStep4Institution(this.currentStep4Institution + 1);
      }
    },
    async getVeriffStatus() {
      const { status, url } = await getVeriffStatus(this.veriff.type);
      if (status === "approved") {
        this.veriffStatus = MESSAGES.FINISHED;
      }
      // this.veriffFrame = createVeriffFrame(url, msg => {
      //   this.veriffStatus = msg;
      // });
    },
    startVeriff(res) {
      if (!res) {
        return;
      } else {
        initVeriff({
          id: this.veriffId,
          type: this.veriff.type,
          handler: (url = "") => {
            // console.log("init veriff with url: %o", url);
            this.veriffFrame = createVeriffFrame(url, msg => {
              this.veriffStatus = msg;
              this.nextStep(msg === MESSAGES.FINISHED);
            });
          }
        });
      }
    },
    verifyIdentity() {
      this.$emit("submitForm", this.startVeriff);
    },
    submitForm() {
      if (this.veriff) {
        this.nextStep(true);
      } else {
        this.$emit("submitForm", this.nextStep);
      }
    },
    async confirm() {
      try {
        await doSubmit();
        this.$router.push({
          ...this.$route,
          query: { ...this.$route.query, state: "100" }
        });
        this.modal2Visible = false;
      } catch (err) {
        displayErrors(err);
      }
    }
  },
  created() {
    if (this.veriff) {
      this.getVeriffStatus();
    }
  }
};
</script>

<style scoped></style>
